/* eslint-disable no-param-reassign */
/* eslint-disable default-case */
import { LOCATION_CHANGE } from 'connected-react-router';
import produce, { setAutoFreeze } from 'immer';
import localForage from 'localforage';
import { persistReducer } from 'redux-persist';

import { SMARTSUPPORT_PROVISIONING_SUBMIT, SMARTSUPPORT_PROVISIONING_SUBMIT_FAILED, SMARTSUPPORT_PROVISIONING_SUBMIT_REQUESTED, SMARTSUPPORT_PROVISIONING_SUBMIT_SUCCEEDED } from './types';

const initialState = {
  smartsupportProvisioningSubmitRequested: false,
  smartsupportProvisioningSubmitSucceeded: false,
  smartsupportProvisioningSubmitFailed: false,
};

const persistConfig = {
  key: 'smartsupport',
  storage: localForage,
  blacklist: ['smartsupportProvisioningSubmitRequested', 'smartsupportProvisioningSubmitSucceeded', 'smartsupportProvisioningSubmitFailed'],
};

setAutoFreeze(false);

const reducer = produce((draft, action) => {
  switch (action.type) {
    case SMARTSUPPORT_PROVISIONING_SUBMIT:
      draft.smartsupportProvisioningSubmitRequested = false;
      draft.smartsupportProvisioningSubmitSucceeded = false;
      draft.smartsupportProvisioningSubmitFailed = false;
      break;

    case SMARTSUPPORT_PROVISIONING_SUBMIT_REQUESTED:
      draft.smartsupportProvisioningSubmitRequested = true;
      draft.smartsupportProvisioningSubmitSucceeded = false;
      draft.smartsupportProvisioningSubmitFailed = false;
      break;

    case SMARTSUPPORT_PROVISIONING_SUBMIT_SUCCEEDED:
      draft.smartsupportProvisioningSubmitRequested = false;
      draft.smartsupportProvisioningSubmitSucceeded = true;
      draft.smartsupportProvisioningSubmitFailed = false;
      break;

    case SMARTSUPPORT_PROVISIONING_SUBMIT_FAILED:
      draft.smartsupportProvisioningSubmitRequested = false;
      draft.smartsupportProvisioningSubmitFailed = true;
      draft.smartsupportProvisioningSubmitRequested = false;
      break;

    case LOCATION_CHANGE:
      console.log('location change');
      draft.smartsupportProvisioningSubmitRequested = false;
      draft.smartsupportProvisioningSubmitSucceeded = false;
      draft.smartsupportProvisioningSubmitFailed = false;
      break;
  }
}, initialState);

export { initialState };
export default persistReducer(persistConfig, reducer);
